import React, { useEffect, useState } from 'react';
import { CrossIcon } from '../../../assets/Icons';
import { API_ENDPOINTS } from '../../utils/endpoints';
import { http_post } from '../../utils/api_client';

export const TeamInviteTitle = () => (
    <div>
        <h1 className="un-auth__q">Invite your team</h1>
        <p className="un-auth__sub">Bring in teammates who'll build or manage training. You can always do this later.</p>
    </div>
);

const TeamInvite = ({ onChangeStep }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [emailFields, setEmailFields] = useState([{ id: 1, email: '' }]);
    const [isDisabled, setIsDisabled] = useState(true);
    const [error, setError] = useState(null);

    const addEmailField = () => {
        setEmailFields(emailFields.concat({ id: Date.now(), email: '' }));
    };

    const removeEmailField = (id) => {
        setEmailFields(emailFields.filter((field) => field.id !== id));
    };

    const handleEmailChange = (id, value) => {
        setEmailFields(emailFields.map((field) => (field.id === id ? { ...field, email: value } : field)));
    };

    const sendInvite = () => {
        setIsLoading(true);
        setError(null);
        http_post(API_ENDPOINTS.POST_INVITE_TEAM, {
            invites: emailFields.filter((f) => f.email)
        })
            .then(() => onChangeStep())
            .catch((err) => {
                setError(err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.');
            })
            .finally(() => setIsLoading(false));
    };

    const inviteLater = () => onChangeStep();

    useEffect(() => {
        setIsDisabled(emailFields.every((field) => field.email === ''));
    }, [emailFields]);

    return (
        <>
            {emailFields.map((field) => (
                <div key={field.id} className="un-auth__invite-row">
                    <input
                        type="email"
                        placeholder="teammate@company.com"
                        value={field.email}
                        onChange={(e) => handleEmailChange(field.id, e.target.value)}
                    />
                    {emailFields.length > 1 && (
                        <button type="button" className="un-auth__invite-x" onClick={() => removeEmailField(field.id)}>
                            <CrossIcon />
                        </button>
                    )}
                </div>
            ))}
            <button type="button" className="un-auth__addmore" onClick={addEmailField}>+ Add another</button>
            {error && <p className="un-auth__err" role="alert">{error}</p>}
            <button className="un-auth__btn un-auth__btn--primary" onClick={sendInvite} disabled={isDisabled || isLoading}>
                {isLoading ? 'Sending…' : 'Send invites & finish'}
            </button>
            <button type="button" className="un-auth__skip" onClick={inviteLater}>I'll do this later</button>
        </>
    );
};

export default TeamInvite;
